import Request from './request'

const DiadocObjectLinks  = {
  getDiadocObjectLinksIndex(params, callback) {
    Request.get('diadoc-object-links/index', params).then(callback).catch(this.bad_answer)
  },
}

export default DiadocObjectLinks
